import { ListeCarteImageTitreLien } from '@components/liste-carte-image-titre-lien/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const listeCarteImageTitreLienMock: Block<ListeCarteImageTitreLien> = {
  type: 'liste-carte-image-titre-lien',
  data: {
    items: [
      {
        title: 'Configurateur Opale',
        subtitle: 'Je dessine ma cuisine en 3D',
        image: imageMock,
        link: 'https://design.socooc.com/opale',
      },
      {
        title: 'Configurateur Smart',
        image: imageMock,
        link: '/configurateur',
      },
    ],
  },
};
